export type Currency = [string, string, string, boolean]

// Top 50 currencies in the world
//   [ISO code, symbol, name, prefixed]
export const currencies: Currency[] = [
  ['USD', '$', 'United States Dollar', true],
  ['EUR', '€', 'Euro', true],
  ['JPY', '¥', 'Japanese Yen', true],
  ['GBP', '£', 'Pound sterling', true],
  ['AUD', '$', 'Australian Dollar', true],
  ['CAD', '$', 'Canadian Dollar', true],
  ['CHF', 'CHF', 'Swiss Franc', false],
  ['CNY', '¥', 'Chinese Yuan', true],
  ['HKD', '$', 'Hong Kong Dollar', true],
  ['NZD', '$', 'New Zealand Dollar', true],
  ['SEK', 'kr', 'Swedish Krona', false],
  ['KRW', '₩', 'South Korean won', true],
  ['SGD', '$', 'Singapore Dollar', true],
  ['NOK', 'kr', 'Norwegian Krone', false],
  ['MXN', '$', 'Mexican Peso', true],
  ['INR', '₹', 'Indian Rupee', true],
  ['RUB', '₽', 'Russian Ruble', true],
  ['ZAR', 'R', 'South African Rand', true],
  ['TRY', '₺', 'Turkish lira', true],
  ['BRL', 'R$', 'Brazilian Real', true],
  ['TWD', '$', 'New Taiwan dollar', true],
  ['DKK', 'kr', 'Danish Krone', false],
  ['PLN', 'zł', 'Polish złoty', false],
  ['THB', '฿', 'Thai Baht', true],
  ['IDR', 'Rp', 'Indonesian Rupiah', true],
  ['HUF', 'Ft', 'Hungarian Forint', false],
  ['CZK', 'Kč', 'Czech Koruna', false],
  ['ILS', '₪', 'Israeli New Shekel', true],
  ['CLP', '$', 'Chilean Peso', true],
  ['PHP', '₱', 'Philippine peso', true],
  ['AED', 'د.إ', 'United Arab Emirates Dirham', true],
  ['COP', '$', 'Colombian Peso', true],
  ['SAR', 'ر.س', 'Saudi Riyal', true],
  ['MYR', 'RM', 'Malaysian Ringgit', true],
  ['RON', 'lei', 'Romanian Leu', false],
  ['VND', '₫', 'Vietnamese dong', true],
  ['EGP', '£', 'Egyptian Pound', true],
  ['ARS', '$', 'Argentine Peso', true],
  ['NGN', '₦', 'Nigerian Naira', true],
  ['BDT', '৳', 'Bangladeshi Taka', true],
  ['PKR', '₨', 'Pakistani Rupee', true],
  ['UAH', '₴', 'Ukrainian hryvnia', true],
  ['MAD', 'DH', 'Moroccan Dirham', false],
  ['KZT', '₸', 'Kazakhstani Tenge', true],
  ['LKR', '₨', 'Sri Lankan Rupee', true],
  ['QAR', 'ر.ق', 'Qatari Riyal', true],
  ['KWD', 'د.ك', 'Kuwaiti Dinar', true],
  ['KES', 'Sh', 'Kenyan Shilling', true],
  ['DZD', 'دج', 'Algerian Dinar', true],
]

// Maps from ISO code to other properties
export const isoToSymbolMap: { [key: string]: string } = {}
export const isoToNameMap: { [key: string]: string } = {}
export const isoToPrefixMap: { [key: string]: boolean } = {}

currencies.forEach(([iso, symbol, name, prefix]) => {
  isoToSymbolMap[iso] = symbol
  isoToNameMap[iso] = name
  isoToPrefixMap[iso] = prefix
})

// Sorted lists
export const sortedByName = [...currencies].sort((a, b) =>
  a[2].localeCompare(b[2]),
)
export const sortedByIso = [...currencies].sort((a, b) =>
  a[0].localeCompare(b[0]),
)
